import React, { useState, useCallback } from 'react';
import { DialogProps } from '@radix-ui/react-dialog';

import { Sheet, SheetContent } from '@epoch-ui/components/Sheet/sheet';
import { Question, QUESTION_TYPE } from 'types/question.types';

import { QuestionnaireQuestionEditor } from './QuestionnaireQuestionEditor/QuestionnaireQuestionEditor';
import { QuestionnaireQuestionTypeSelector } from './QuestionnaireQuestionTypeSelector';

interface EditQuestionnaireQuestionSideSheetProps extends DialogProps {
  question?: Question;
}

export const EditQuestionnaireQuestionSideSheet: React.FC<
  EditQuestionnaireQuestionSideSheetProps
> = ({ question, onOpenChange, ...props }) => {
  const [selectedType, setSelectedType] = useState<QUESTION_TYPE | null>(null);

  const handleCloseSheet = useCallback(
    (open: boolean): void => {
      onOpenChange?.(open);
      if (!open) {
        setTimeout(() => {
          setSelectedType(null);
        }, 300);
      }
    },
    [onOpenChange]
  );

  return (
    <Sheet onOpenChange={handleCloseSheet} {...props}>
      <SheetContent className="tw-m-2 tw-flex tw-h-[98.2%] tw-w-[480px] tw-max-w-[480px] tw-flex-col tw-rounded-lg tw-pb-4 sm:tw-max-w-[75%] md:tw-max-w-[40%] xl:tw-max-w-[36%]">
        {selectedType === null && !question ? (
          <QuestionnaireQuestionTypeSelector onSelect={(type) => setSelectedType(type)} />
        ) : (
          <QuestionnaireQuestionEditor
            type={question?.type ?? selectedType!}
            onBack={() => setSelectedType(null)}
            handleClose={() => handleCloseSheet(false)}
            question={question}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};
